import { isRecord } from "./type-guards";

type ToastState = {
  severity: "success" | "info" | "warn" | "error";
  summary: string;
  detail: string;
  life?: number;
};

type LocationStateWithToast = {
  toast?: {
    severity?: unknown;
    summary?: unknown;
    detail?: unknown;
    life?: unknown;
  };
};

function isToastSeverity(value: unknown): value is ToastState["severity"] {
  return (
    typeof value === "string" &&
    (value === "success" || value === "info" || value === "warn" || value === "error")
  );
}

export function getToastStateFromLocationState(state: unknown): ToastState | null {
  if (!isRecord(state)) return null;

  const locationState = state as LocationStateWithToast;
  const toast = locationState.toast;
  if (!isRecord(toast)) return null;

  const severity = toast.severity;
  if (!isToastSeverity(severity)) {
    return null;
  }

  const summary = toast.summary;
  const detail = toast.detail;
  const life = toast.life;

  if (typeof summary !== "string" || typeof detail !== "string") return null;
  if (life != null && typeof life !== "number") return null;

  return {
    severity,
    summary,
    detail,
    life: typeof life === "number" ? life : undefined,
  };
}


